import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 25 25",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="M15.75 8a3.25 3.25 0 1 1-6.5 0 3.25 3.25 0 0 1 6.5 0Zm-3 11.25h-5.3c-1.18 0-2.06-1.04-1.46-2.055C6.863 15.723 8.74 14 12.75 14m7 5.25-3.5-3.5m0 3.5 3.5-3.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />' }
  })
);